//src/shared/services/services
import api from "../../features/auth/axiosConfig";
import { Configurations, UOMInterface } from "./interface";

const user = "pos/user_details";
const Product = "app/v1/pos/product";
const category = "/app/v1/pos/category";
const customer = "app/v1/pos/customer";
const Order = "/app/v1/pos/order";
const orderReturn = "/app/v1/pos/order_reverse";
const cancelOrder = "/app/v1/pos/cancel_order?orderid=";
const categotyExport = "/app/v1/export/category";
const categotyImport = "/app/v1/import/category";
const productExport = "/app/v1/export/product";
const productImport = "/app/v1/import/product";
const themes = `pos/theme`;
const profile = `pos/profile`;
const ledger = "pos/ledger";
const profileAdd = "pos/add";
const ledgerCustomer = "pos/ledger/customer";
const Dashboard = "/app/v1/pos/dashboard";
const staff = "/app/v1/pos/staff";
const employee = "/pos/add";
const getemployee = "/pos/get_user";
const Config = "/app/v1/configuration";
const OrderReverse = "/app/v1/pos/order_reverse";

export const getUser = async () => {
  try {
    const responce = await api.get(user);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getProduct = async (
  data?: boolean,
  page?: number,
  row?: number,
  search?: string,
  categoryid?: string,
  sortField?: string,
  order?: string,
) => {
  try {
    const responce = await api.get(
      `${Product}?include_deleted=${data || "false"}&pageNumber=${page || ""}&pageSize=${row || ""}&searchBy=${search || ""}&category_id=${
        categoryid || ""
      }&sortField=${sortField || ""}&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postProduct = async (data: any) => {
  try {
    const responce = await api.post(Product, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putProduct = async (id: string, data: any) => {
  try {
    const responce = await api.put(`${Product}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteProduct = async (data: any) => {
  try {
    const responce = await api.delete(Product, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getCategory = async (data?: boolean, page?: number, row?: number, search?: string, sortField?: string, order?: string) => {
  try {
    const responce = await api.get(
      `${category}?include_deleted=${data || false}&pageNumber=${page || 1}&pageSize=${row || ""}&searchBy=${search || ""}&sortField=${
        sortField || ""
      }&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postCategory = async (data: any) => {
  try {
    const responce = await api.post(category, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchCategory = async (data: any, id: string) => {
  try {
    const responce = await api.put(`${category}/${id}`, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (data: any) => {
  try {
    const responce = await api.delete(category, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postCustomer = async (customerData: any) => {
  try {
    const responce = await api.post(customer, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putCustomer = async (id: string, customerData: any) => {
  try {
    const responce = await api.put(`${customer}/${id}`, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchCustomer = async (id: string, customerData: any) => {
  try {
    const responce = await api.patch(`${customer}/${id}`, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getCustomer = async (sataus?: boolean, page?: number, row?: number, searchTerm?: string, sortField?: string, order?: string) => {
  try {
    const url = `${customer}?include_deleted=${sataus || false}&pageNumber=${page}&pageSize=${row}&searchBy=${
      searchTerm || ""
    }&sortField=${sortField}&sortOrder=${order}`;
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteCustomer = async (data: any) => {
  try {
    const responce = await api.delete(customer, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postOrder = async (postData: any) => {
  try {
    const responce = await api.post(Order, postData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getOrder = async (
  id?: string,
  page?: number,
  limit?: number,
  from?: string,
  to?: string,
  name?: string,
  staff?: string,
  sortField?: string,
  order?: string,
  status?: string,
) => {
  // console.log("url", id);
  const url = id ? `${Order}/${id}` : Order;
  const pageURL = `${Order}?pageNumber=${page}&pageSize=${limit}&dateFilter=custom&startDate=${from}&endDate=${to}&searchBy=${
    name || ""
  }&staff_name=${staff}&sortField=${sortField}&sortOrder=${order}&OrderStatus=${status}`;
  const orderUrl = page ? pageURL : url;
  try {
    const responce = await api.get(orderUrl);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const orderReturnId = async (id: string, data: any) => {
  const url = `${orderReturn}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchOrder = async (id: string, data: any) => {
  const url = `${Order}/${id}`;
  try {
    const responce = await api.patch(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const exportCategory = async () => {
  try {
    const responce = await api.get(categotyExport, {
      responseType: "blob",
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const importCategory = async (file: any) => {
  try {
    const responce = await api.post(categotyImport, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};
export const exportProduct = async () => {
  try {
    const responce = await api.get(productExport, {
      responseType: "blob",
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const importProduct = async (file: any) => {
  try {
    const responce = await api.post(productImport, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putTheme = async (file: any) => {
  try {
    const responce = await api.put(themes, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const responce = await api.get(profile);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putProfile = async (file: any, Id: string) => {
  try {
    const responce = await api.put(`${profile}/${Id}`, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgers = async (page?: number, pageSize?: number, searchBy?: string, sortField?: string, order?: string, osbnull?: boolean) => {
  const ledgerPageView = `${ledger}?pageNumber=${page}&pageSize=${pageSize}&searchBy=${searchBy}&sortField=${sortField}&sortOrder=${order}&includeSettled=${osbnull}`;
  try {
    const responce = await api.get(ledgerPageView);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgersId = async (id: string) => {
  try {
    const responce = await api.get(`${ledger}/${id}`);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postLedgers = async (data: any) => {
  try {
    const responce = await api.post(ledger, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgersCustomer = async (id: string) => {
  try {
    const responce = await api.get(`${ledgerCustomer}/${id}`);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putMyProfile = async (file: any, Id: string) => {
  try {
    const responce = await api.put(`${profileAdd}/${Id}`, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const dashBoard = async (From?: string, to?: string) => {
  const url = From && to ? `${Dashboard}?start_date=${From}&end_date=${to}` : Dashboard;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const staffData = async () => {
  const url = `${staff}?include_deleted=false`;
  try {
    const response = await api.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token: string, newPassword: string, confirmPassword: string) => {
  try {
    const response = await api.post(`/reset-password/${token}`, {
      new_password: newPassword,
      confirm_password: confirmPassword,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// UOM APIs

export const getUOM = async () => {
  try {
    const res = await api.get("/app/v1/uom");
    return res;
  } catch (error) {
    throw error;
  }
};

export const postUOM = async (uomInput: UOMInterface) => {
  try {
    const res = await api.post("/app/v1/uom", uomInput);
    return res;
  } catch (error) {
    throw error;
  }
};

export const exportOrder = async (
  exportFormate: string,
  search: string,
  pageNumber: number,
  pageSize: number,
  startDate: string,
  endDate: string,
  OrderStatus: string,
) => {
  try {
    const responce = await api.get(
      `${
        exportFormate === "pdf" ? `/pos/order_export_${exportFormate}` : `/app/v1/import_export?`
      }?searchBy=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}&dateFilter=custom&startDate=${startDate}&endDate=${endDate}&OrderStatus=${OrderStatus}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLogo = async (imagePath: string) => {
  try {
    // 🚨 Block empty or non-png extensions
    if (!imagePath || !imagePath.toLowerCase().endsWith(".png")) {
      return null;
    }

    const res = await api.get(`/pos/logo?filename=${imagePath}`, {
      responseType: "arraybuffer",
    });

    return res;
  } catch (error: any) {
    // 🚨 Silently ignore 404
    if (error?.response?.status === 404) {
      return null;
    }
    console.log(error);
    throw error;
  }
};

// /app/v1/configuration

export const GetConfigurationPageSetup = async () => {
  try {
    const res = api.get(Config);
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const postConfigurationPageSetup = async (pageConfiguration: Configurations) => {
  try {
    const res = api.put(Config, pageConfiguration, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const patchConfigurationPageSetup = async (pageConfiguration: any) => {
  try {
    const res = api.put(Config, pageConfiguration, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

//order cancel api

export const putOrder = async (id: string, data: any) => {
  const url = `${cancelOrder}${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};
export const putOrderEdit = async (id: string, data: any) => {
  const url = `${OrderReverse}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

// employee management APIs

export const postEmployee = async (data: any) => {
  const url = `${employee}`;
  try {
    const responce = await api.post(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getEmployee = async () => {
  const url = `${getemployee}`;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const editEmployee = async (id: string, data: any) => {
  const url = `${employee}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployee = async (id: string) => {
  const url = `${employee}/${id}`;
  try {
    const responce = await api.delete(url);
    return responce;
  } catch (error) {
    throw error;
  }
};
